// import currencyCodes from 'currency-codes';
// import moment from 'moment';
// import ISO6391 from 'iso-639-1';
// import countries from 'vuei18n-iso-countries';

import auth from '../plugins/auth';

export const MainUtils = {
  data () {
    return {
      validationErrors: {}
    }
  },
  computed: {
    validationFieldErrors () {
      let errors = {};

      for (let errorPath in this.validationErrors) {
        let fieldErrors = this.validationErrors[errorPath]
        // TODO find a generic way to resolve deep nested structures like i.e. "relation[i].items[j].field"
        let deepPathMatches = errorPath.match(/([a-z]+)\[(\d+)\]\.?([a-z]+)?/i);
        if (deepPathMatches) {
          let relationName = deepPathMatches[1];
          let relationIndex = deepPathMatches[2];
          let relationField = deepPathMatches[3] || '$self';
          if (!errors[relationName]) {
            errors[relationName] = [];
          }
          if (!errors[relationName][relationIndex]) {
            errors[relationName][relationIndex] = {};
          }
          errors[relationName][relationIndex][relationField] = fieldErrors;
        } else {
          errors[errorPath] = fieldErrors;
        }
      }
      return errors;
    }
  },
  methods: {
    objectValueByAnnotationString (object, annotationString) {
      let objectParts = annotationString.split('.');

      for (let objectPart of objectParts) {
        if (object[objectPart] == null) {
          return false;
        }

        object = object[objectPart];
      }

      return object;
    },

    hasAnyPermission(requestedPermissions) {
      return auth.hasAnyPermission(requestedPermissions);
    },

    /**
     * @param {string} message If undefined, general unexpected error message is used
     */
    showSuccessNotification (message) {
      this.$toast.success(message, {
        icon: 'mdi-check-circle'
      });
    },

    showSavedSuccessfullyNotification () {
      this.showSuccessNotification(this.$t('notifications.successfully_saved'));
    },

    showDeletedSuccessfullyNotification () {
      this.showSuccessNotification(this.$t('notifications.successfully_deleted'));
    },

    /**
     * @param {string} [errorMessage] If undefined, general unexpected error message is used
     */
    showErrorNotification (errorMessage) {
      errorMessage = errorMessage || this.$t('error.general');
      this.$root.$errorDialog(errorMessage);
    },

    /**
     * @param {string} [errorMessage] If undefined, general unexpected error message is used
     */
    showErrorToast (errorMessage) {
      errorMessage = errorMessage || this.$t('error.general');
      this.$toast.error(errorMessage, {
        icon: 'mdi-alert-circle'
      });
    },

    getValidationErrors(response, showNotification = true) {
      let errorData;
      try {
        errorData = JSON.parse(new TextDecoder().decode(response.data));
      } catch (e) {
        errorData = response.body;
      }

      if(response.status === 400) {
          const validationErrors = errorData.validationErrors;
          if(validationErrors != null) {
            if(showNotification) {
              this.showErrorToast(this.$t('error.pleaseCheckYourInput'));
            }
            return validationErrors;
          }
      }

      if(showNotification) {
        this.handleErrorResponse(response);
      }

      return {'': [this.getErrorMessageByResponse(response)]};
    },

    clearValidationErrors () {
      this.validationErrors = {};
    },

    handleErrorResponse (response) {
      console.warn(response);
      this.showErrorNotification(
        this.getErrorMessageByResponse(response)
      );
    },

    handleErrorResponseSilent (response) {
      if(response && response.status === 403) {
        return;
      }
      console.warn(this.getErrorMessageByResponse(response));
    },

    getErrorMessageByResponse (response) {
      let errorMessage = this.$t('error.unexpectedErrorOccured');
      let errorData;
      try {
        errorData = JSON.parse(new TextDecoder().decode(response.data));
      } catch (e) {
        errorData = response.body;
      }
      if (errorData && errorData.message) {
        errorMessage = errorData.message;
      } else if(response.status === 0) {
        errorMessage = this.$t('error.serverConnection');
      }
      return errorMessage;
    },

    setIsGlobalLoadingOverlay (isGlobalLoading) {
      this.$store.dispatch('setIsGlobalLoading', isGlobalLoading)
    },

    showGlobalLoadingOverlay () {
      this.setIsGlobalLoadingOverlay(true);
    },

    hideGlobalLoadingOverlay () {
      this.setIsGlobalLoadingOverlay(false);
    },

    onlyUnique (value, index, self) {
      return self.indexOf(value) === index;
    },

    /**
     * @param {string} url
     * @param {string} defaultFilename
     * @return {Promise<>}
     */
    downloadFile(url, defaultFilename) {
      return this.$http.get(url, {responseType: 'arraybuffer'})
          .then(response => {
            this.downloadResponseAsFile(response, defaultFilename)
          });
    },

    downloadResponseAsFile (response, defaultFilename) {
      let filename = defaultFilename || 'file';
      let disposition = response.headers.get('Content-Disposition');
      if (disposition) {
        let matches = /filename="?([a-zA-ZäÄüÜöÖßéèê\-_+0-9.()&$,#\s]*)"?/.exec(disposition);
        filename = (matches != null && matches[1] ? matches[1] : filename);
      }

      let blob = new Blob([response.data])
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    }
  }
};
